// Section 9 and 16: Common hall. 14 build points, 12 wood and 6 stone; belonging need met for
// everyone (the consumption phase counts the hall, D-25); enables festivals (the festival policy
// validates it); trust recovery 1.5x: every trust gain from the Section 16 table is multiplied
// (scaled by condition, D-13). Limit 1. Constants: config.buildings['common-hall'].
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import {
  buildingEffectHook,
  combineModifiers,
  effective,
  noDeltas,
} from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';
import type { TrustCause } from '../../core/types';

/** The Section 16 trust-table rows that raise trust ("recovery"). */
const RECOVERY: readonly TrustCause[] = [
  'fed-full-while-others-short',
  'treated-short-medicine',
  'given-tool',
  'all-needs-met',
  'promised-build',
  'festival',
];

export function commonHall(config: Config) {
  const c = config.buildings['common-hall'];

  return defineBuilding({
    id: 'common-hall',
    label: 'Common hall',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood, stone: c.stone },
    material: 'wood',
    beds: 0,
    plots: 0,
    capacity: {},
    limit: { kind: 'fixed', max: c.limit },
    modifierTargets: ['trustChange', 'buildingEffect'],
    modifierKeys: { trustChange: RECOVERY },
    modifiers: combineModifiers(buildingEffectHook('common-hall'), (ctx, target) => {
      if (target.kind !== 'trustChange' || !RECOVERY.includes(target.cause)) return [];
      const e = Math.min(1, effective(ctx, 'common-hall'));
      return e > 0
        ? [mod.mul('building:common-hall', 1 + (c.trustRecovery - 1) * e, 'common hall')]
        : [];
    }),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
